import React, { useState, useEffect } from 'react';
import './App.css'; // 我们也会稍微调整一下 CSS

function App() {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch('/images.json')
            .then(response => {
                if (!response.ok) {
                    throw new Error('无法加载图片配置文件');
                }
                return response.json();
            })
            .then(data => {
                setImages(data);
            })
            .catch(err => {
                setError(err.message);
                console.error("获取图片配置失败:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <div className="status">正在加载图片...</div>;
    }

    if (error) {
        return <div className="status error">加载图片失败: {error}</div>;
    }

    return (
        <div className="App">
            {/* 保留一个总的 <h1> 标题 */}
            {/*<h1>我的图片画廊</h1>*/}

            <div className="gallery">
                {images.map(image => (
                    <div key={image.id} className="image-card">
                        <h2>{image.alt}</h2>
                        <img src={image.url} alt={image.alt}/>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default App;